import { render, staticRenderFns } from "./applyShengneiSett.vue?vue&type=template&id=4b6ec8ee&scoped=true&"
import script from "./applyShengneiSett.vue?vue&type=script&lang=js&"
export * from "./applyShengneiSett.vue?vue&type=script&lang=js&"
import style0 from "./applyShengneiSett.vue?vue&type=style&index=0&id=4b6ec8ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6ec8ee",
  null
  
)

export default component.exports